import { useContext, useEffect, useState } from 'react'
import { VanContext } from '../../../../../global/context/van-context/VanContext'
import { fetchData } from '../../../../../global/utils/fetch'
import { getFaultCodes, VanFaultCodeResult } from '../../../../api'
import styles from './styles.module.css'

function FaultCodesSection() {
  const { vanData } = useContext(VanContext)
  const [faultData, setFaultData] = useState<VanFaultCodeResult | null>(null)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    async function fetchFaultData() {
      if (!vanData?.objectId) return

      setIsLoading(true)
      try {
        const allFaultCodes = await fetchData<VanFaultCodeResult[]>(
          getFaultCodes(),
        )
        const vanFaultData = allFaultCodes.find(
          (fc) => fc.vanObjectId === vanData.objectId,
        )
        setFaultData(vanFaultData ?? null)
      } catch (error) {
        console.error('Error fetching fault codes:', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchFaultData()
  }, [vanData?.objectId])

  if (isLoading) {
    return (
      <div className={styles.container}>
        <h3 className={styles.header}>Fault Codes</h3>
        <p>Loading...</p>
      </div>
    )
  }

  if (!faultData || !faultData.hasActiveFaults) {
    return (
      <div className={styles.container}>
        <h3 className={styles.header}>Fault Codes</h3>
        <p className={styles.noFaults}>No active fault codes</p>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.header}>Fault Codes</h3>
      <div className={styles.faultList}>
        {faultData.faultCodes.map((fault) => (
          <div key={fault.dtcId ?? fault.code} className={styles.faultItem}>
            <span className={styles.faultCode}>{fault.code}</span>
            {fault.description && (
              <span className={styles.faultDescription}>
                {fault.description}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FaultCodesSection
